<!-- <div class="mb-3 col-md-1 ml-md-auto">
    <a routerLink="/confrmList" class="btn btn-outline-danger btn-sm" role="button" aria-pressed="true">View Confirm List</a>
  
     </div> -->
<div class="card mb-4">
    <div class="card-body">
        <div *ngIf="showTable; else formView">
            <div class="mb-4 d-md-flex align-items-center justify-content-between">
            </div>
            <div class="row">
                <div class="col-md-12">
                    <div class="row">
                        <div class="col-md-10">
                            <h3 class="text-center font-bold font-up danger-text">Pending Order List</h3>
                        </div>
                    </div>
                </div>
            </div>
            <button (click)="deleteSelectedEntries()" class="btn btn-outline-danger mb-3"><i class="feather icon-trash-2"></i></button>
            <div class="table-responsive" *ngIf="orderList.length > 0; else noDataMessage">
                <table class="table mb-0 table-centered table-bordered">
                    <thead>
                        <tr>
                          <th><input type="checkbox" id="selectAllCheckbox" (change)="selectAllChanged($event)"></th>
                            <th>Ticket No</th>
                            <th>Ref No</th>
                            <th>PO No</th>
                            <th>Client Name</th>
                            <th>Job Name</th>
                            <th>Job Type</th>
                            <th>Order Kgs</th>
                            <th>FD Option</th>
                            <th>Status</th>
                            <th>Action</th>
                        </tr>
                    </thead>
  
                    <!-- Add *ngFor loop for displaying user data -->
                    <tbody>
                        <tr *ngFor="let order of orderList">
                          <td><input type="checkbox" class="rowCheckbox" [attr.data-id]="order._id"></td>
                            <td>{{ order.ticketno }}</td>
                            <td>{{ order.refNo }}</td>
                            <td>{{ order.poNo }}</td>
                            <td>{{ order.clientName}}</td>
                            <td>{{ order.jobName }}</td>
                            <td>{{ order.jobType }}</td>
                            <td>{{ order.orderKgs | number:'1.2-2':'en-US'}}</td>
                            <td>{{ order.fdOption }}</td>
                            <td>
                              <!-- class="badge badge-md badge-soft-success" -->
                                <button 
                                    
                                    class="btn btn-outline-success btn-sm"
                                    title="Click to Confirm order"
                                    (click)="openConfirmationForm(order)"
                                    >Pending
                            </button>
                            </td>
                            <td>
                                <button type="button" class="btn btn-outline-primary btn-sm"
                                 (click)="saveOrder()" 
                                 [routerLink]="['/editorderList', order._id]"> 
                                 <i class="feather icon-edit "></i>Edit
                                </button>
                                
                            </td>
                  
                        </tr>
                    </tbody>
                </table><!--end /table (click)="saveOrder()"  routerLink="/UnsavedOrder/{{order._id}}" --> 
            </div><!--end /tableresponsive-->
  
            <div class="pagination-container">
              <div class="pagination mt-3 d-flex justify-content-between align-items-center">
                <div>
                  <p>Showing {{ calculateRangeStart() }} - {{ calculateRangeEnd() }} of {{ totalItems }}</p>
                </div>
  
                <div class="d-flex">
                  <a class="pagination-btn pt-2" (click)="onPageChange(currentPage - 1)" [ngClass]="{'disabled': currentPage === 1}">
                    <i class="feather icon-chevrons-left"></i>
                  </a>
                
                  <ng-container *ngFor="let page of getNumberRange(ceil(totalItems / itemsPerPage))">
                    <a class="pagination-circle" [class.active]="currentPage === page" (click)="onPageChange(page)">
                      {{ page }}
                    </a>
                    <span *ngIf="page < ceil(totalItems / itemsPerPage)" class="page-number-space"></span>
                  </ng-container>
                
                  <a class="pagination-btn pt-2" (click)="onPageChange(currentPage + 1)" [ngClass]="{'disabled': currentPage === ceil(totalItems / itemsPerPage)}">
                    <i class="feather icon-chevrons-right"></i>
                  </a>
                </div>
  
              </div>
            </div>
          </div>
        
  
          <ng-template #formView>
            <div class="mb-4 d-md-flex align-items-center justify-content-between">
        
                <div>
                    <h3>Complete Job info and Save</h3>
                    <p>Kindly check all the information and correct all mistakes and update, then save</p>
                </div>
            </div>
            <div class="form-card">
                <form (ngSubmit)="submitForm()" [formGroup]="editOrderForm">
                  <div class="row">
                    <div class="col-md-4 mb-3"> <label class="form-label">Client Name</label> <input type="text" class="form-control"
                        formControlName="clientName" [value]="selectedClient?.clientName" readonly>
                    </div>
                    <div class="col-md-4 mb-3"> <label for="ticketno" class="form-label">Ticket No</label> <input type="text"
                        formControlName="ticketno" id="ticketno" class="form-control" readonly />
                    </div>
                    <div class="col-md-4 mb-3"> <label for="ddDate" class="form-label">Delivey Date</label>
                      <input type="date" formControlName="ddDate" id="ddDate" class="form-control" />
                  
                    </div>
                  </div>
                    <div class="row">
                    <div class="col-md-4 mb-3"> <label for="jobName" class="form-label">Job Name</label> <input type="text"
                        formControlName="jobName" id="jobName" class="form-control" placeholder="Enter Job Name"/> </div>
                    <div class="col-md-4 mb-3"> <label for="jobType" class="form-label">Job Type</label>
                      <div class="input-group"> 
                        <select formControlName="jobType" id="jobType" class="form-control minimal">
                          <option value="" disabled>Select Job Type</option>
                          <option value="Roll Form">Roll Form</option>
                          <option value="Kgs/Pcs">Kgs/Pcs</option>
                          <!-- <option value="Sleeves">Sleeves</option>
                          <option value="Labels">Labels</option> -->
                        </select> 
                      </div>
                    </div>
                    <div class="col-md-4 mb-3"> <label for="refNo" class="form-label">Ref No</label> <input type="text"
                        formControlName="refNo" id="refNo" class="form-control" placeholder="Enter Ref No"/> </div>
                    </div>
                    <div class="row">
                      <div class="col-md-6 mb-3"> <label for="sMat" class="form-label">Standard Material Structure</label>
                        <div class="input-group input-group2">
                          <select formControlName="sMat" id="sMat" class="form-control minimal">
                            <option value="" disabled>Select Standard Material Structure</option>
                            <option value="CLEAR BOPP">CLEAR BOPP</option>
                            <option value="MET BOPP">MET BOPP</option>
                            <option value="PEARL BOPP">PEARL BOPP</option>
                            <option value="MATT BOPP">MATT BOPP</option>
                            <option value="CLEAR PET">CLEAR PET</option>
                            <option value="CLEAR PP">CLEAR PP</option>

                            <option value="CT PET">CT PET</option>
                            <option value="CC PET">CC PET</option>
                            <option value="CT+CC PET">CT+CC PET</option>
                            <option value="SHRINK PET (PETG)">SHRINK PET (PETG)</option>
                            <option value="MET PET">MET PET</option>
                            <option value="MATT PET">MATT PET</option>
                            <option value="PVC TWIST CLEAR">PVC TWIST CLEAR</option>
                            <option value="PVC SHRINK">PVC SHRINK</option>
                            <option value="PVC TWIST ORANGE">PVC TWIST ORANGE</option>
                            <option value="CPP MET">CPP MET</option>
                            <option value="CPP CLEAR">CPP CLEAR</option>
                            <option value="LDPE -SHRINK">LDPE -SHRINK</option>
                            <option value="LDPE LAMINATION">LDPE LAMINATION</option>
                            <option value="LDPE CLEAR">LDPE CLEAR</option>
                            <option value="LDPE WHITE">LDPE WHITE</option>
                            <option value="FOIL ALU">FOIL ALU</option>
                            <option value="HDPE CLEAR">HDPE CLEAR</option>
                            <option value="WIP">WIP</option>
                          </select>
                          <div
                            *ngIf="editOrderForm.get('sMat')?.invalid && (editOrderForm.get('sMat')?.dirty || editOrderForm.get('sMat')?.touched)"
                            class="text-danger">
                            <div *ngIf="editOrderForm.get('sMat')?.errors?.required">Standard Material Structure is required.
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-6 mb-3 d-flex ">
                        <div class="col-md-6 mb-3"> <label for="thickness" class="form-label">Material Thickness (µ)</label>
                          <input type="text" formControlName="thickness" id="thickness" class="form-control"
                            placeholder="Enter Thickness (in µ)" />
                          <div
                            *ngIf="editOrderForm.get('thickness')?.invalid && (editOrderForm.get('thickness')?.dirty || editOrderForm.get('thickness')?.touched)"
                            class="text-danger">
                            <div *ngIf="editOrderForm.get('thickness')?.errors?.required">Thickness is required.</div>
                          </div>
                        </div>
                        <div class="col-md-6 mb-3 ms-2"> <label for="width" class="form-label">Material Width (mm)</label>
                          <input type="text" formControlName="width" id="width" class="form-control"
                            placeholder="Enter Width (mm)" />
                          <div
                            *ngIf="editOrderForm.get('width')?.invalid && (editOrderForm.get('width')?.dirty || editOrderForm.get('width')?.touched)"
                            class="text-danger">
                            <div *ngIf="editOrderForm.get('width')?.errors?.required">Width is required.</div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="form-group mb-3" [formGroup]="editOrderForm.get('material1')">
                      <div class="row d-flex">
                          <div class="col form-group mb-3">
                      <label for="sMat2" class="form-label">Standard Material Structure (Optional)</label>
                      <select formControlName="sMat2" id="sMat2" class="form-control minimal">
                        <option value="" disabled>Select Standard Material Structure</option>
                        <option value="CLEAR BOPP">CLEAR BOPP</option>
                        <option value="MET BOPP">MET BOPP</option>
                        <option value="PEARL BOPP">PEARL BOPP</option>
                        <option value="MATT BOPP">MATT BOPP</option>
                        <option value="CLEAR PET">CLEAR PET</option>
                        <option value="CLEAR PP">CLEAR PP</option>

                        <option value="CT PET">CT PET</option>
                        <option value="CC PET">CC PET</option>
                        <option value="CT+CC PET">CT+CC PET</option>
                        <option value="SHRINK PET (PETG)">SHRINK PET (PETG)</option>
                        <option value="MET PET">MET PET</option>
                        <option value="MATT PET">MATT PET</option>
                        <option value="PVC TWIST CLEAR">PVC TWIST CLEAR</option>
                        <option value="PVC SHRINK">PVC SHRINK</option>
                        <option value="PVC TWIST ORANGE">PVC TWIST ORANGE</option>
                        <option value="CPP MET">CPP MET</option>
                        <option value="CPP CLEAR">CPP CLEAR</option>
                        <option value="LDPE -SHRINK">LDPE -SHRINK</option>
                        <option value="LDPE LAMINATION">LDPE LAMINATION</option>
                        <option value="LDPE CLEAR">LDPE CLEAR</option>
                        <option value="LDPE WHITE">LDPE WHITE</option>
                        <option value="FOIL ALU">FOIL ALU</option>
                        <option value="HDPE CLEAR">HDPE CLEAR</option>
                        <option value="WIP">WIP</option>
                      </select>
                      <button *ngIf="editOrderForm.get('material1.sMat2').value" type="button" class="btn btn-secondary mt-2" (click)=" resetmaterial1()">Reset</button>
                      </div>
                    
                      <div class="col form-group mb-3">
                        <label class="form-label">Material Thickness (µ)(Optional)</label>
                        <input type="text"
                               [formControl]="editOrderForm.get('material1.thickness2')"
                               id="thickness2" 
                               class="form-control" 
                               placeholder="0" />
                      </div>
                        <div class="col form-group mb-3">
                          <label class="form-label">Material Width (mm)(Optional)</label>
                          <input type="text"
                                 [formControl]="editOrderForm.get('material1.width2')"
                                 id="width2" 
                                 class="form-control" 
                                 placeholder="0" />
                        </div>
                        
                     
                    </div>
                    </div>
                    
                    <div class="form-group mb-3" [formGroup]="editOrderForm.get('material2')">
                      <div class="row d-flex">
                          <div class="col form-group mb-3">
                      <label for="sMat3" class="form-label">Standard Material Structure (Optional)</label>
                      <select formControlName="sMat3" id="sMat3" class="form-control minimal">
                        <option value="" disabled>Select Standard Material Structure</option>
                        <option value="CLEAR BOPP">CLEAR BOPP</option>
                        <option value="MET BOPP">MET BOPP</option>
                        <option value="PEARL BOPP">PEARL BOPP</option>
                        <option value="MATT BOPP">MATT BOPP</option>
                        <option value="CLEAR PET">CLEAR PET</option>
                        <option value="CLEAR PP">CLEAR PP</option>

                        <option value="CT PET">CT PET</option>
                        <option value="CC PET">CC PET</option>
                        <option value="CT+CC PET">CT+CC PET</option>
                        <option value="SHRINK PET (PETG)">SHRINK PET (PETG)</option>
                        <option value="MET PET">MET PET</option>
                        <option value="MATT PET">MATT PET</option>
                        <option value="PVC TWIST CLEAR">PVC TWIST CLEAR</option>
                        <option value="PVC SHRINK">PVC SHRINK</option>
                        <option value="PVC TWIST ORANGE">PVC TWIST ORANGE</option>
                        <option value="CPP MET">CPP MET</option>
                        <option value="CPP CLEAR">CPP CLEAR</option>
                        <option value="LDPE -SHRINK">LDPE -SHRINK</option>
                        <option value="LDPE LAMINATION">LDPE LAMINATION</option>
                        <option value="LDPE CLEAR">LDPE CLEAR</option>
                        <option value="LDPE WHITE">LDPE WHITE</option>
                        <option value="FOIL ALU">FOIL ALU</option>
                        <option value="HDPE CLEAR">HDPE CLEAR</option>
                        <option value="WIP">WIP</option>
                      </select>
                      <button *ngIf="editOrderForm.get('material2.sMat3').value" type="button" class="btn btn-secondary mt-2" (click)=" resetmaterial2()">Reset</button>
                      </div>
                    
                      <div class="col form-group mb-3">
                        <label class="form-label">Material Thickness (µ)(Optional)</label>
                        <input type="text"
                               [formControl]="editOrderForm.get('material2.thickness3')"
                               id="thickness3" 
                               class="form-control" 
                               placeholder="0" />
                      </div>
                        <div class="col form-group mb-3">
                          <label class="form-label">Material Width(mm)(Optional)</label>
                          <input type="text"
                                 [formControl]="editOrderForm.get('material2.width3')"
                                 id="width3" 
                                 class="form-control" 
                                 placeholder="0" />
                        </div>
                     
                     
                    </div>
                    </div>
                    <div class="row">
                    <div class="col-md-4 mb-3"> <label for="poDate" class="form-label">PO Received Date</label> <input
                        type="date" formControlName="poDate" id="poDate" class="form-control" /> </div>
                    <div class="col-md-4 mb-3"> <label for="poNo" class="form-label">PO No</label> <input type="text"
                        formControlName="poNo" id="poNo" class="form-control" placeholder="Enter PO No"/> </div>
                    <div class="col-md-2 mb-3"> <label for="coilod" class="form-label">Coil OD</label> <input
                        type="text" formControlName="coilod" id="coilod" class="form-control" placeholder="Enter Coil OD"/> </div>
                    <div class="col-md-2 mb-3"> <label for="coilWidth" class="form-label">Coil Width</label> <input
                        type="text" formControlName="coilWidth" id="coilWidth" class="form-control" placeholder="Enter Coil Width"/> </div>
                    </div>
                    <div class="row">
                    <div class="col-md-3 mb-3"> <label for="sRemrk" class="form-label">Shade Remark</label> <input
                        type="text" formControlName="sRemrk" id="sRemrk" class="form-control" placeholder="Enter Shade Remark"/> </div>
                    <div class="col-md-3 mb-3"> <label for="barcode" class="form-label">Barcode Number</label> <input
                        type="text" formControlName="barcode" id="barcode" class="form-control" placeholder="Enter Barcode Number"/> </div>
                    <div class="col-md-3 mb-3"> <label for="dispatch" class="form-label">Dispatch Type</label> <input
                        type="text" formControlName="dispatch" id="dispatch" class="form-control" placeholder="Enter Dispatch Type"/> </div>
                    <div class="col-md-3 mb-3"> <label for="remark" class="form-label">Remark</label> <input type="text"
                        formControlName="remark" id="remark" class="form-control" placeholder="Enter Remark"/> </div>
                    </div>
                    <div class="row">
                      <div class="col-md-4 mb-3">
                        <label for="orderPcs" class="form-label ml-3">Order Pcs</label>
                        <input type="text" formControlName="orderPcs" id="orderPcs" class="form-control ml-2"
                          placeholder="Enter Pcs to calculate" />
                        <button type="button" class="btn btn-outline-success btn-sm ml-3" (click)="togglePcsGram()"
                          title="Calculate">
                          <i class="feather ticket "></i>Calculate
                        </button>
                      </div>
    
                      <!-- Hidden by default, shown after clicking "Calculate" -->
                      <div class="col-md-4 mb-3" *ngIf="showPcsGram">
                        <span>Total order in pcs={{totalPcs}}</span>
                        <label for="gram" class="form-label">Pcs/gram =</label>
                        <input type="text" formControlName="gram" id="gram" class="form-control" />
                        <button type="button" class="btn btn-outline-success btn-sm ml-3" title="Calculate"
                          (click)="calculateOrderKgs()">
                          <i class="feather ticket "></i>Cal kg
                        </button>
                      </div>
    
                      
                      <div class="col-md-4 mb-3">
                        <label for="orderKgs" class="form-label">|| Order Kgs</label>
                        <input type="text" formControlName="orderKgs" id="orderKgs" class="form-control"
                          placeholder="Enter quantity in Kg" />
                      </div>
                  </div>
                  <div class="row">
                    <div class="col-md-3 mb-3"> <label for="fdOption" class="form-label">Final Direction Option</label>
                      <div class="input-group"> <select formControlName="fdOption" id="fdOption"
                          class="form-control custom-select minimal">
                          <option value="" disabled>Select Final Direction</option>
                          <option value="EMRS">EMRS</option>
                          <option value="EMLS">EMLS</option>
                          <option value="Readable">Readable</option>
                          <option value="Non-Readable">Non-Readable</option>
                          <option value="Any Direction">Any Direction</option>
                          <option value="Direction not Required">Direction not Required</option>
                        </select> </div>
                    </div>
                    <div class="col-md-3 mb-3"> <label for="packageType" class="form-label">Packaging Type</label>
                      <div class="input-group"> <select formControlName="packageType" id="packageType"
                          class="form-control custom-select minimal">
                          <option value="" disabled>Select Packaging Type</option>
                          <option value="Pallets">Pallets</option>
                          <option value="Bundles">Bundles</option>
                          <option value="Box">Box</option>
                          <option value="Others">Others</option>
                        </select> </div>
                    </div>
                    <!-- <div class="col-md-6 mb-3 d-flex "> -->
                      <div class="col-md-3 mb-3"> <label for="prepare" class="form-label">Prepared By</label> <input
                          type="text" formControlName="prepare" id="prepare" class="form-control" placeholder="Prepared By"/> </div>
                      <div class="col-md-3 mb-3"> <label for="approved" class="form-label">Approved By</label> <input
                          type="text" formControlName="approved" id="approved" class="form-control" placeholder="Approved By"/> </div>
                    <!-- </div> -->
                  </div>
                    <div class="col-md-12 text-end"> 
                        <button type="submit" class="btn  btn-outline-info">Update</button> 
                        <button class="btn btn-outline-danger ms-2">Cancel</button>
                     </div>
                </form>
            </div>
        </ng-template>
    </div>
  </div>
    
  <div *ngIf="showConfirmationForm" class="card mt-3 confirmation-form">
    <div class="card-body">
        <h4 class="card-title">Confirmation Form</h4>
        <form [formGroup]="confirmationForm">
            <div class="mb-3">
                <label for="department" class="form-label">Department:</label>
                <input type="text" id="department" formControlName="department" class="form-control">
            </div>
            <div class="mb-3">
                <label for="sign" class="form-label">Signature:</label>
                <input type="text" id="sign" formControlName="sign" class="form-control">
            </div>
            <!-- Inside the confirmation form in your HTML template -->
<button class="btn btn-outline-success btn-sm me-2" (click)="handleConfirmation()" [disabled]="isConfirming">Submit</button>
<button class="btn btn-outline-primary btn-sm " (click)="onCancel()">Cancel</button>

        </form>
    </div>
</div>

<ng-template #noDataMessage>
    <div class="alert alert-warning" role="alert">
        There is no data available.
    </div>
</ng-template>